import React, { useState, useEffect } from 'react';

const domains = [
  {
    icon: '⚙️',
    label: 'Productivité',
    stat: '+40%',
    desc: "de tâches répétitives automatisables dans une entreprise moyenne",
    bar: 40,
    source: 'McKinsey Global Institute',
  },
  {
    icon: '🎯',
    label: 'Marketing & Ads',
    stat: '5×',
    desc: "plus de contenu publicitaire généré à budget équivalent grâce à l'IA",
    bar: 83,
    source: 'HubSpot Research',
  },
  {
    icon: '💬',
    label: 'Service Client',
    stat: '70%',
    desc: "des interactions clients pourraient être gérées ou assistées par l'IA",
    bar: 70,
    source: 'Gartner',
  },
  {
    icon: '📊',
    label: 'Prise de décision',
    stat: '3×',
    desc: "plus rapide avec l'analyse de données en temps réel par agents IA",
    bar: 66,
    source: 'MIT Sloan Management',
  },
  {
    icon: '💰',
    label: 'Réduction des coûts',
    stat: '-30%',
    desc: "de coûts opérationnels estimés après intégration de workflows IA",
    bar: 30,
    source: 'Accenture',
  },
];

export default function ImpactSlider() {
  const [active, setActive] = useState(0);
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    setAnimated(false);
    const t = setTimeout(() => setAnimated(true), 50);
    return () => clearTimeout(t);
  }, [active]);

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % domains.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const d = domains[active];

  return (
    <div className="impact-slider">
      <p className="impact-eyebrow">Potentiel IA par domaine métier</p>

      <div className="impact-tabs">
        {domains.map((item, i) => (
          <button
            key={item.label}
            className={`impact-tab${i === active ? ' active' : ''}`}
            onClick={() => setActive(i)}
          >
            <span>{item.icon}</span>
            <span>{item.label}</span>
          </button>
        ))}
      </div>

      <div className={`impact-card${animated ? ' visible' : ''}`}>
        <div className="impact-stat">{d.stat}</div>
        <p className="impact-desc">{d.desc}</p>

        <div className="impact-bar-wrap">
          <div
            className="impact-bar-fill"
            style={{ width: animated ? `${d.bar}%` : '0%' }}
          />
        </div>

        <p className="impact-source">Source : {d.source}</p>
      </div>
    </div>
  );
}
